module.exports = __webpack_public_path__ + "static/media/my-account-bg.ecd096c4.jpg";